import { c as _c } from "react/compiler-runtime";
import { darkTextureWrapper, colorSettingDetection, renderHeaderConditionally } from "../../utils/functions";
import { SearchButton } from "../../component/SearchButton/SearchButton";
import { LatestArticle, LatestArticleProps } from "./LatestArticle";
import { featuredPost, FeaturedPosts } from "./FeaturedPosts";
import { ActionBlock } from "../../component/ActionBlock/ActionBlock";
import { ExternalFormProps } from "../../component/ExternalForm/ExternalForm";
import { TerraLink } from "../../component/TerraLink/TerraLink";
import { layoutHeaderClasses, layoutHeaderBigClasses } from "@/components/tailwindHelpers";

// import "./BlogDigest.css"

export interface BlogDigest {
  eyebrow?: string;
  header?: string;
  headerElement?: "h1" | "h2";
  searchPlaceholderText: string;
  onSearch?: (value: string) => void;
  latestArticle: LatestArticleProps;
  featuredPostsTitle?: string;
  featuredPosts?: featuredPost[];
  subscribeForm?: boolean;
  formDisplayType?: "email" | "buttons";
  formHeader?: string;
  formPlaceholder?: string;
  formData?: ExternalFormProps;
  buttons?: [TerraLink] | undefined;
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  isHeaderBig?: boolean;
  isWrapped?: boolean;
  overrideLinkBehavior?: "normal" | "all-new-tab" | "all-same-tab";
  onChange?: (value: any) => void;
  componentImagePriority?: "high" | "auto" | "low";
}
export const BlogDigest = t0 => {
  const $ = _c(50);
  const {
    eyebrow,
    header,
    headerElement: t1,
    searchPlaceholderText,
    onSearch,
    latestArticle,
    featuredPostsTitle,
    featuredPosts,
    subscribeForm,
    formDisplayType: t2,
    formHeader,
    formPlaceholder,
    formData,
    buttons,
    isHeaderBig,
    isWrapped,
    presetTheme,
    overrideLinkBehavior: t3,
    onChange,
    componentImagePriority
  } = t0;
  const headerElement = t1 === undefined ? "h1" : t1;
  const formDisplayType = t2 === undefined ? "buttons" : t2;
  const overrideLinkBehavior = t3 === undefined ? "normal" : t3;
  const wrapperClasses = `${isWrapped ? "w-full px-5 lg:px-20 m-auto max-w-[1440px]" : ""}`;
  const t4 = presetTheme || "";
  let t5;
  if ($[0] !== t4) {
    t5 = colorSettingDetection(t4);
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const colorSetting = t5;
  const mainClasses = `${presetTheme || ""} ${colorSetting}`;
  const headerClasses = `${isHeaderBig ? layoutHeaderBigClasses : layoutHeaderClasses}
`;
  const t6 = header || "";
  let t7;
  if ($[2] !== headerClasses || $[3] !== headerElement || $[4] !== t6) {
    t7 = renderHeaderConditionally(headerClasses, t6, headerElement);
    $[2] = headerClasses;
    $[3] = headerElement;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const finalHeader = t7;
  const t8 = presetTheme || "";
  let t9;
  if ($[6] !== t8) {
    t9 = darkTextureWrapper(t8);
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const componentStyles = t9;
  let t10;
  if ($[8] !== overrideLinkBehavior) {
    t10 = (item, index, children) => {
      if (item?.destination !== undefined) {
        return <TerraLink key={`featured-post-${item?.destination}-${index}`} className="flex pb-10 no-underline items-center hover:underline hover:text-inherit last:pb-0" destination={item?.destination} linkType="text" openInSameTabExternalLink={overrideLinkBehavior === "all-same-tab"}>{children}</TerraLink>;
      } else {
        return <div key={`featured-post-${index}`} className="flex pb-10 no-underline items-center hover:underline hover:text-inherit last:pb-0">{children}</div>;
      }
    };
    $[8] = overrideLinkBehavior;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const wrapImageListItem = t10;
  const t11 = `${mainClasses} py-20 pb-0`;
  let t12;
  if ($[10] !== eyebrow || $[11] !== finalHeader || $[12] !== onChange || $[13] !== onSearch || $[14] !== searchPlaceholderText) {
    t12 = (finalHeader || eyebrow) && <div className="flex gap-32 items-center mb-5 flex-row max-lg:flex-col max-lg:gap-12 max-sm:mb-12"><div className="w-[630px] max-lg:w-full">{eyebrow && <div className="text-blue-trmb uppercase text-lg font-bold leading-7 tracking-wide max-sm:text-sm max-sm:leading-normal max-sm:tracking-relaxed t2-dark:text-white">{eyebrow}</div>}{finalHeader}</div>{onSearch && <div className="max-sm:w-full"><SearchButton label={searchPlaceholderText} onSearch={onSearch} onChange={onChange} /></div>}</div>;
    $[10] = eyebrow;
    $[11] = finalHeader;
    $[12] = onChange;
    $[13] = onSearch;
    $[14] = searchPlaceholderText;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = overrideLinkBehavior === "all-same-tab";
  let t14;
  if ($[16] !== componentImagePriority || $[17] !== latestArticle || $[18] !== t13) {
    t14 = <LatestArticle {...latestArticle} openInSameTabExternalLink={t13} componentImagePriority={componentImagePriority} />;
    $[16] = componentImagePriority;
    $[17] = latestArticle;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== featuredPostsTitle) {
    t15 = <h2 className="text-blue-trmb uppercase text-lg font-bold leading-7 tracking-wide pb-12 max-sm:text-sm max-sm:leading-normal max-sm:tracking-relaxed t2-dark:text-white">{featuredPostsTitle}</h2>;
    $[20] = featuredPostsTitle;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== componentImagePriority || $[23] !== featuredPosts || $[24] !== wrapImageListItem) {
    t16 = featuredPosts && <FeaturedPosts featuredPosts={featuredPosts} wrapImageListItem={wrapImageListItem} componentImagePriority={componentImagePriority} />;
    $[22] = componentImagePriority;
    $[23] = featuredPosts;
    $[24] = wrapImageListItem;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t15 || $[27] !== t16) {
    t17 = <div className="">{t15}{t16}</div>;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t14 || $[30] !== t17) {
    t18 = <div className="flex gap-24 flex-row pb-15 max-lg:flex-col max-lg:gap-16 max-sm:gap-12">{t14}{t17}</div>;
    $[29] = t14;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== buttons || $[33] !== formData || $[34] !== formDisplayType || $[35] !== formHeader || $[36] !== formPlaceholder || $[37] !== subscribeForm) {
    t19 = subscribeForm && <div className=""><ActionBlock displayType={formDisplayType} formPlaceholder={formPlaceholder} header={formHeader} presetTheme="t2-action-theme-one" formData={formData} buttons={formDisplayType === "buttons" ? buttons : undefined} /></div>;
    $[32] = buttons;
    $[33] = formData;
    $[34] = formDisplayType;
    $[35] = formHeader;
    $[36] = formPlaceholder;
    $[37] = subscribeForm;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t12 || $[40] !== t18 || $[41] !== t19) {
    t20 = <div className="">{t12}{t18}{t19}</div>;
    $[39] = t12;
    $[40] = t18;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t20 || $[44] !== wrapperClasses) {
    t21 = <div className={wrapperClasses}>{t20}</div>;
    $[43] = t20;
    $[44] = wrapperClasses;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== componentStyles || $[47] !== t11 || $[48] !== t21) {
    t22 = <div className={t11} style={componentStyles}>{t21}</div>;
    $[46] = componentStyles;
    $[47] = t11;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  return t22;
};